import { useEffect } from "react";

// Keeps an Optro import tracker polling while the calling view is on screen
// (see useOptroImportJobs). Takes the tracker's registerInterest, or undefined
// when the tracker isn't available or the view isn't showing.
export const useOptroImportInterest = (
  registerInterest: (() => () => void) | undefined,
) => {
  useEffect(() => registerInterest?.(), [registerInterest]);
};
